import { Link } from "react-router-dom";
import Reveal from "./Reveal";

export default function CTABand() {
  return (
    <section className="cta-band" data-testid="cta-band">
      <div className="cta-inner">
        <Reveal>
          <span className="eyebrow" style={{ color: "#fff", borderColor: "rgba(255,255,255,0.3)" }}>
            <span className="dot" />
            Ready To Roll Out
          </span>
          <h2>
            Ready to track every bag? <br />
            <em>Start with your district.</em>
          </h2>
        </Reveal>
        <Reveal delay={120}>
          <div className="cta-buttons">
            <Link to="/login" className="btn-primary" data-testid="cta-band-login">
              Admin Login <i className="fa-solid fa-arrow-right"></i>
            </Link>
            <a href="#contact" className="btn-ghost" data-testid="cta-band-contact">
              Talk to Sales
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
